<template>
  <section>
    <el-dialog
        width="780px"
        :visible.sync="visible"
        class="global-dialog template-manage-dialog"
        custom-class="items-container">
      <div slot="title" class="tmd-title">
        <template  v-if="object.templates && object.templates[0].label">
          <span class="template-icon tpl-group-icon" v-text="object.templates[0].label"></span>
        </template>
        <template v-else>
          <span class="template-icon tpl-group-icon" v-if="!isTeamTemplate(object.type)"><i class="icon"></i>图文</span>
        </template>
        <span> {{object.groupName}}</span>
      </div>
      <draggable v-model="object.templates" @end="onDragEnd"
                 :handle="isProjectUser? '.no-drag': '.m-item'"
                 ghostClass="drop-receiver-class"
                 dragClass="drag-move-class">
        <div class="m-item" :key="index" v-for="(item, index) in object.templates">
          <div class="item-box" @click.stop="goToEditor(item)" style="cursor: pointer">
            <img :src="item.defaultUrl">
            <div class="mask">
              <div class="opration">
                <div class="template-icon-btn tpl-edit-icon" @click.stop="onClickUse(item)">
                  <i class="icon myico-edit"></i>
                  <div>编辑</div>
                </div>
                <div class="template-icon-btn tpl-use-icon" @click.stop="previewTemplate(index, item)">
                  <i class="icon"></i>
                  <div>预览</div>
                </div>
              </div>
            </div>
            <p v-if="item.hidden" class="tpl-hidden c-tip" title="普通用户无法看到当前模板">模板已隐藏</p>
            <p v-else-if="item.canCommercial === false" class="tpl-commercial-mark">
              <i class="mark-icon myico myico-no"></i><span class="mark-text">不可商用</span>
            </p>
          </div>
          <div class="item-box-footer">
            <div class="item-name c-ellipsis"><span>{{item.name}}</span></div>
            <el-popover
                v-if="$store.getters['app/isAdmin'] && menuVisible && !isPreTemplate(object)"
                popper-class="no-arrow"
                placement="right-start"
                trigger="hover"
                visible-arrow=false>
              <ul>
                <li @click="onClickUpdateTemplate(item)">修改模板配置</li>
                <!--<li @click="onClickSwitchTemplate(item)" v-if="freeTplBtnVisible(item)">生成自由模板</li>-->
                <li v-if="item.hidden" @click="onHide(item)">取消隐藏</li>
                <li v-else @click="onHide(item)">隐藏</li>
                <el-popover placement="bottom-end"
                            popper-class="c-delete-propper delete-propper-work"
                            v-if="$store.getters['app/isAdmin']"
                            v-model="item.visible1">
                  <p><i class="el-icon-warning"></i>你确认要删除该模板吗？</p>
                  <div style="text-align: right; margin: 0">
                    <el-button @click="item.visible1=false">取消</el-button>
                    <el-button type="primary" @click="item.visible1=false; deleteOneTemplate(item)">确定</el-button>
                  </div>
                  <li slot="reference">删除</li>
                </el-popover>
              </ul>
              <div class="item-menu" slot="reference">
                <i class="el-icon-more"></i>
              </div>
            </el-popover>
            <div class="item-size">{{item.widthHeight}}</div>
          </div>
        </div>
      </draggable>
    </el-dialog>
    <self-carsoursel v-if="templatePreview" v-model="templatePreview" :index="current" :data="object.templates"
                     :key="22"
                     type="template" @switch="onSwitchPng">
      <template v-slot:bottom="props">
        <div class="m-preview-bottom">
          <div class="opration">
            <el-button type="primary" round @click="toUseTemplate(props.data)">使用模板</el-button>
          </div>
          <div class="info">
            <span class="title">{{props.data.name}}</span>
            <span class="size">{{props.data.widthHeight}}</span>
          </div>
        </div>
      </template>
    </self-carsoursel>
  </section>
</template>
<script>
    import selfCarsoursel from '../self-carousel';
    import templateService from '../../../request/service/template-service'
    import {template_type_multiple, template_type_single, template_type_free} from '@/const.js';
    import draggable from 'vuedraggable';

    export default {
        components: {
            selfCarsoursel, draggable
        },
        props: {
            value: Boolean,
            object: {
                type: Object,
                default() {
                    return {}
                }
            }
        },
        data() {
            return {
                current: 0,
                templatePreview: false,
                menuVisible: true,
                freeType: template_type_free
            }
        },
        computed: {
            visible: {
                get() {
                    return this.value;
                },
                set(val) {
                    this.$emit('input', val);
                }
            },
            projectId() {
                return this.$store.state.app.projectId;
            },
            isProjectUser() {
                return this.$store.getters['app/isProjectUser'];
            },
        },
        methods: {
            isTeamTemplate(type) {
                return type === template_type_single // 单图模板
            },
            goToEditor(item) {
                // if (item.type !== template_type_single) {
                //     this.goToTplGroupEditor(item.id);
                //     this.saveUserAction(this.ActionType.template.name.key, this.ActionType.templateGroup.goToEditor.key, item.type, item.id);
                // } else {
                //     this.toUse(item.id);
                //     this.saveUserAction(this.ActionType.template.name.key, this.ActionType.template.goToEditor.key, item.type, item.id);
                // }
                this.saveUserAction(this.ActionType.template.name.key, this.ActionType.template.goToEditor.key, item.type, item.id);
                this.forward(item.type, item.id, item.free);
            },
            onClickUse(item) {
                // if (item.type !== template_type_single) {
                //     // this.goToTplGroupEditor(item.id);
                //     this.saveUserAction(this.ActionType.template.name.key, this.ActionType.templateGroup.edit.key, item.type, item.id);
                // } else {
                //     // this.toUse(item.id);
                //     this.saveUserAction(this.ActionType.template.name.key, this.ActionType.template.edit.key, item.type, item.id);
                // }
                this.saveUserAction(this.ActionType.template.name.key, this.ActionType.template.edit.key, item.type, item.id);
                this.forward(item.type, item.id, item.free);
            },
            forward(type, id, free) {
                this.$emit('onForward', type, id, free);
            },
            toUseTemplate(item) {
                // if (item.type !== template_type_single) {
                //     this.goToTplGroupEditor(item.id);
                // } else {
                //     this.toUse(item.id);
                // }
                this.saveUserAction(this.ActionType.template.name.key, this.ActionType.template.useTemplate.key, item.type, item.id);
                this.forward(item.type, item.id, item.free);
            },
            previewTemplate(index, item) {
                this.current = index;
                this.templatePreview = true;
                this.saveUserAction(this.ActionType.template.name.key, this.ActionType.template.preview.key, item.type, item.id);
            },
            deleteOneTemplate(item) {
                templateService.deleteTemplates([item.id]).then(() => {
                    let index = this.object.templates.findIndex((el) => {
                        return el.id == item.id;
                    });
                    this.object.templates.splice(index, 1);
                    if (this.object.templates.length === 0) {
                        this.$emit('clearItem', this.object);
                    }
                    this.$message({
                        duration: 1000,
                        message: '删除成功',
                        type: 'success'
                    });
                }).catch((e) => {
                    console.log(e);
                })
            },
            onSwitchPng() {
                this.saveUserAction(this.ActionType.template.name.key, this.ActionType.template.switch.key);
            },
            onClickUpdateTemplate(item) {
                this.visible = false;
                this.menuVisible = false;
                this.$emit('onClickUpdateTemplate', item);
                this.$nextTick(() => { //刷新操作菜单 ，否则文字不会切换
                    this.menuVisible = true;
                })
            },
            onDragEnd() {
                let result = {};
                this.object.templates.forEach((item, i) => {
                    result[item.id] = i + 1;
                });
                templateService.sortTemplates(result);
            },
            onHide(item) {
                this.menuVisible = false;
                this.$emit('onOneHide', item);
                item.hidden = !item.hidden;
                this.$nextTick(() => { //刷新操作菜单 ，否则文字不会切换
                    this.menuVisible = true;
                })
            },
            onClickSwitchTemplate(item) {
                this.$emit('onClickSwitchTemplate', item);
            },
            freeTplBtnVisible(item) {
                return this.$store.getters['app/freeTplVisible'] && !item.free;
            },
            isPreTemplate({projectId}){// 模板列表页，预置模板只能跳转到编辑页，不能做修改
                let isUserTemplatePage = this.$route.path === '/template';
                return projectId === this.$store.state.app.loginUser.preliminaryProject.id && isUserTemplatePage;
            },
        }
    }
</script>

